import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux';
import { RootState } from '../reducers';
import { useDispatch } from 'react-redux';
import useEffectOnce from '../hooks/useEffectOnce';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Message } from 'primereact/message';
import { LoginService } from '../services/LoginService';
import { getSpecialityData } from '../reduxactions/adminactions/AdminPlanActions';
import { Card } from 'primereact/card';
import { Panel } from 'primereact/panel';
import { Admin_API, PATIENT_API } from '../ApiNames';

export const PatientFeedback = () => {
    const uid = window.sessionStorage.getItem('uid');

    const [globalFilter, setGlobalFilter] = useState('');
    const dispatch = useDispatch();
    const location = useLocation();

    const [queryParams, setQueryParams] = useState(null);
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        setQueryParams(params.get("id") as any);
    }, [location]);
    const { id } = useParams();

    //To get data
    const [data, setData] = useState<[]>([]);
    const fetchDocDetails = async () => {
      try {
        const payload = { doctorid: id, q: 5 };
        const apiname = PATIENT_API.detailsfee_API;
        const response = await LoginService.getData(apiname, payload);
        setData(response);
       
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    const [data1, setData1] = useState<[]>([]);
    const [avgtime,setAvgTime]=useState('');
    const fetchTimeDetails = async () => {
        try {
          const payload = { doctorid: id, q: 6 };
          const apiname = PATIENT_API.detailsfee_API;
          const response = await LoginService.getData(apiname, payload);
          setData1(response);
          setAvgTime(response[0].avgresponse)
        } catch (error) {
          console.error('Error fetching data:', error);
        }
      };
    useEffectOnce(() => {
        fetchDocDetails();
        fetchTimeDetails();
    }, [dispatch]);
   
    return (
        <div className="admin-layout-container">
            <div className="content-wrapper" style={{ marginLeft: '100px' }}>
                <section className="content-header">
                    <div className="container-fluid">
                        <div className="grid mb-2">
                            <div className="col-6">
                            </div>
                        </div>
                    </div>
                </section>
                <section className="content" style={{ marginLeft: '110px' }} >
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card-header p-2" style={{ marginTop: '50px' }}>
                                <h2>Feedback</h2>
                            </div>
                            <br></br>
                            
                            <div className="box box-primary">
                            <h3 className='text-center'> Average Response Time : Hrs {avgtime} Min </h3>                               
                             <div className="card">
                                    <p className="m-0">
                                        <div>
                                            <div className="card flex flex-wrap justify-content">
                                                <span className="p-input-icon-left">
                                                    <i className="pi pi-search" style={{ paddingLeft: '5px' }} />
                                                    <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Global Search" style={{ paddingLeft: '25px' }} />
                                                </span>

                                            </div>
                                            <DataTable value={data} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} filters={{ global: { value: globalFilter, matchMode: 'contains' } }}
                                                            globalFilterFields={['Category', 'Amount', 'Amount', 'Status']}>
                                                <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                                                <Column field="Category"  header="Created Date"></Column>
                                                <Column field="Amount"  header="Overallsatiesfaction"></Column>
                                                <Column field="Amount" header="Suggestion"></Column>
                                               
                                            </DataTable>

                                        </div>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            



           


        </div>
    )
}
